var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9987 4.33913L20.4024 5.88144C20.2657 5.98798 20.1961 6.16079 20.2258 6.3336V17.6677C20.1974 17.8392 20.2645 18.0133 20.4024 18.1199L21.9626 19.6622V20H14.1191V19.6622L15.7348 18.0822C15.8934 17.9224 15.8934 17.8743 15.8934 17.63V8.46841L11.4024 19.9636H10.795L5.5665 8.46841V16.1722C5.52266 16.497 5.62968 16.8218 5.85533 17.0557L7.95706 19.6245V19.9623H2V19.6245L4.10044 17.057C4.3248 16.8218 4.42538 16.4931 4.37122 16.1722V7.26393C4.39701 7.01705 4.30288 6.77278 4.1185 6.60646L2.25143 4.33913V4.0013H8.0499L12.5319 13.9048L16.4723 4H22V4.33783L21.9987 4.33913Z",
    fill: "#C6FCA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.f8a81a1aa5f81b227b991a6d831d824b.svg";
export { ForwardRef as ReactComponent };